// extracted by mini-css-extract-plugin
export default {"provider":"providers_provider__SM5KS","provider__name":"providers_provider__name__puiep"};